import { Checkbox } from "antd";
import { Backdrop } from "@mui/material";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { toast, ToastContainer } from "react-toastify";
// import CheckBox from "./ReactTableFiles/CheckBox";
// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import CheckBox from "../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import TableViewIcon from "@mui/icons-material/TableView";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
import Loader from "../../../components/Loader";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import InfoIcon from "@mui/icons-material/Info";
import { dateFormatter } from "../../../helper/helper";
import IconButton from "@mui/material/IconButton";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import "../../../../src/assets/css/material-dashboard_1.css";
import Tooltip from "@mui/material/Tooltip";

export default function FilterTableCampaignVoiceUpload({
  showtable,
  instantshow,
}) {
  const [open, setOpen] = useState();
  const [openvoiceprompt1, setopenvoiceprompt1] = useState(false);
  const [openvoiceprompt2, setopenvoiceprompt2] = useState(false);
  const [data, setData] = useState([]);
  const [Voicedata, setVoicedata] = useState(undefined);
  const [Voicedata1, setVoicedata1] = useState(undefined);

  const voiceData = useRef(null);
  const voiceDataClose = useRef(null);

  const voiceData1 = useRef(null);
  const voiceDataClose1 = useRef(null);

  const voicemodal = (cell) => {
    setopenvoiceprompt2(false);
    setVoicedata(cell?.row?.original?.obdFileUpload);
    voiceData.current.click();
  };
  const voicemodal1 = (cell) => {
    setopenvoiceprompt2(true);
    console.log("play2", cell.row.original);
    setopenvoiceprompt1(false);
    setVoicedata1(cell?.row?.original?.campaignCallsDetails);
    voiceData1.current.click();
  };

  const handlechangedownload = (e, data) => {
    console.log("this is value,,,,kkk", instantshow);
  };

  console.log("data table------", data);
  console.log("data table1------", instantshow);

  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };

  const rejectUserApi = async () => {};
  const approveUserApi = async (cell) => {};

  const approveUser = async (cpId) => {};

  // .............................Delete Post API..................................................//

  async function DeletePost(values) {}

  const columns = useMemo(
    () => [
      // {
      //   Header: "ID",
      //   Footer: "ID",
      //   accessor: "userId", // accessor is the "key" in the data
      // },
      {
        Header: "Voice Plan",
        Footer: "Voice Plan",
        accessor: "voicePlan", // accessor is the "key" in the data
      },
      {
        Header: "Campaign Type",
        Footer: "Campaign Type",
        accessor: "campaignType", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   console.log("hhuudu", cell.row.original.obdType[0]);
        //   // return <>{dateFormatter(cell.row.original.createdDate)}</>;
        // },
      },
      //   {
      //     Header: "Prompts",
      //     Footer: "Prompts",
      //     // accessor: "obdFileUpload", // accessor is the "key" in the data
      //     Cell: (cell) => {
      //       return (
      //         <IconButton
      //           aria-label="delete"
      //           // type="button"
      //           //   id="dropdownMenuButton1"
      //           //   data-bs-toggle="dropdown"
      //           //   aria-expanded="false"
      //           onClick={() => {
      //             setopenvoiceprompt1(true);
      //             console.log("play", cell.row.original);
      //             voicemodal(cell);

      //             // rejectUserModal(cell);
      //           }}
      //         >
      //           <PlayCircleOutlineIcon />
      //         </IconButton>
      //       );
      //     },
      //   },

      //   {
      //     Header: "Campaign Name",
      //     Footer: "Campaign Name",
      //     accessor: "eventName",
      //   },

      // {
      //   Header: "Audio File Name",
      //   Footer: "Audio File Name",
      //   accessor: "senderId",
      // },
      {
        Header: "Approved Status",
        Footer: "Status",
        accessor: "status",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1  "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {console.log("aaa", cell.row.original.approved)}
              {cell.row.original.status == 1 ? (
                <>
                  <span class="badge bg-success activated_1">Success</span>
                </>
              ) : cell.row.original.status == 0 ? (
                <>
                  <span class="badge bg-warning activated_1">
                    Pending For Approval
                  </span>
                </>
              ) : (
                <>
                  <span class="badge bg-danger activated_1">Rejected</span>
                </>
              )}
            </button>
          </div>
        ),
      },
      {
        Header: "Created Date",
        Footer: "Created Date",
        accessor: "createdOn",
        Cell: (cell) => {
          return <>{dateFormatter(cell.row.original.createdDate)}</>;
        },
      },

      //   {
      //     Header: "End DateTime",
      //     Footer: "End DateTime",
      //     accessor: "endDate",
      //     Cell: (cell) => {
      //       return <>{dateFormatter(cell.row.original.endDate)}</>;
      //     },
      //   },
    ],
    []
  );

  // console.log(Status, "lalalaallalas");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  const getarray = async () => {
    // setData(JSON.parse(instantshow));
    setData(instantshow);
    // try {
    //   setOpen(true);
    //   //   alert("working");
    //   const resulttable = await common_axios.get(
    //     "http://192.168.167.66:5050/admin/v1/voice-campaign/get-all"
    //   );
    //   console.log("resultttttmainnnn", resulttable);
    //   if (resulttable.data.statusDescription.statusCode == 200) {
    //     setOpen(false);
    //     // toast.success(resulttable.data.statusDescription.statusMessage, {
    //     //   theme: "colored",
    //     // });
    //     setData(resulttable.data.campaigns);
    //     setOpen(false);
    //   } else {
    //     setOpen(false);
    //     toast.error(resulttable.data.statusDescription.statusMessage, {
    //       theme: "colored",
    //     });
    //   }
    // } catch (error) {
    //   // alert("catch block");
    //   setOpen(false);
    //   console.log(error);
    // }
  };

  useEffect(() => {
    if (showtable == true) {
      getarray();
    }
  }, [showtable, instantshow]);

  return (
    <section className="cmp">
      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        {/* {openvoiceprompt2 == true ? ( */}
        <div>
          <button
            ref={voiceData1}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-xl  modal_box">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Campaign Report Summary
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  {/* <div className="col-md-6"> */}

                  <div className="table-responsive">
                    {/* <span className="d-block">{Olddata?.label}</span> */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            Camp. ID
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            Total Call
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            Answered
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            No Ans.
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            User Busy
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            Switch Off
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            User Not Responding
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            Other
                          </th>
                          <th scope="col" style={{ border: "1px solid black" }}>
                            Download Campaign Report
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Voicedata1 &&
                          Voicedata1.map((data) => {
                            return (
                              <>
                                <tr>
                                  <th scope="row">{data.id}</th>
                                  <td>{data.totalCalls}</td>
                                  <td>{data.successCalls}</td>
                                  <td>{data.systemFailure}</td>
                                  <td>{data.noAnswer}</td>
                                  <td>{data.totalCalls}</td>
                                  <td>{data.successCalls}</td>
                                  <td>{data.systemFailure}</td>
                                  <td>
                                    <IconButton
                                      // aria-label="delete"
                                      onClick={(e) => {
                                        handlechangedownload(e, data);
                                      }}
                                      style={{ height: "20px" }}
                                    >
                                      {/* <Tooltip title="Download Report"> */}{" "}
                                      <CloudDownloadIcon />
                                      {/* </Tooltip> */}
                                    </IconButton>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* </div> */}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      rejectUserApi();
                    }}
                  >
                    Approve
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ) : ( */}
        <></>
        {/* )} */}

        {/* {openvoiceprompt1 == true ? ( */}
        <div>
          <button
            ref={voiceData}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Voice Prompts
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  {/* <div className="col-md-6"> */}
                  <span className="d-block font-weight-bold">
                    Preview Voice
                  </span>
                  <div className=" align-items-center">
                    {/* <span className="d-block">{Olddata?.label}</span> */}

                    {Voicedata &&
                      Voicedata.map((data) => {
                        return (
                          <>
                            {/* <div className="row"> */}
                            <audio
                              className="mt-2 w-100"
                              controls
                              src={data?.downlaodUrl}
                            >
                              <a href={data?.downlaodUrl}>Download audio</a>
                            </audio>
                            {/* </div> */}
                          </>
                        );
                      })}
                  </div>
                  {/* </div> */}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  {/* <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      rejectUserApi();
                    }}
                  >
                    Approve
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ) : ( */}
        <></>
        {/* )} */}

        {selectedUserDetail != undefined && (
          <div>
            <button
              ref={modelButtonReject}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Reject User
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <h4>User Information</h4>
                    <h5>User ID:{selectedUserDetail.id}</h5>
                    <h5>User ID:{selectedUserDetail.firstName}</h5>
                    <h5>User ID:{selectedUserDetail.role}</h5>
                    <h5>User ID:{selectedUserDetail.email}</h5>
                    <div>
                      <label>
                        Rejected Reason
                        <input
                          type="text"
                          value={selectedUserDetail.rejectedReason}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              rejectedReason: e.target.value,
                            });
                          }}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        rejectUserApi();
                      }}
                    >
                      Reject User
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {selectedUserDetailApprove != undefined && (
          <div>
            <button
              ref={modelButtonApprove}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdrop1Label">
                      Approve User
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <h4>User Information</h4>
                    <h5>User ID:{selectedUserDetailApprove.id}</h5>
                    <h5>User ID:{selectedUserDetailApprove.firstName}</h5>
                    <h5>User ID:{selectedUserDetailApprove.role}</h5>
                    <h5>User ID:{selectedUserDetailApprove.email}</h5>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        approveUserApi();
                      }}
                    >
                      Approve User
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="container-fluid">
          {/* <div class="card mb-3 mt-4"> */}
          <div class="card-body mt-2">
            {/* <ul class="nav nav-tabs pt-5" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                >
                  User
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                >
                  User Group
                </button>
              </li>
            </ul> */}
            <div>
              {/* <div>
                <Checkbox {...getToggleHideAllColumnsProps()} /> Toggle All
                Columns
              </div> */}
              <div></div>
            </div>
            {/* <div class="dropdown">
              <button
                class="btn bg-gradient-primary dropdown-toggle m-0"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onChange={(e) => setStatus(e.target.value)}
              >
                Status
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a
                    class="dropdown-item"
                    value="pending"
                    onClick={() => {
                      setStatus("allUser");
                    }}
                  >
                    All Users
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    value="pending"
                    onClick={() => {
                      setStatus("pending");
                    }}
                  >
                    Pending
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    value="approved"
                    //   onChange={(e) => setStatus(e.target.value)}
                    onClick={() => {
                      setStatus("approved");
                    }}
                  >
                    Approveds
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    value="rejected"
                    onClick={() => {
                      setStatus("rejected");
                    }}
                  >
                    Rejected
                  </a>
                </li>
              </ul>
            </div> */}

            {/* <div className="d-flex justify-content-between my-3">
              <select
                value={pageSize}
                className="dropdown"
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
              >
                {[10, 25, 50].map((value, i) => {
                  return (
                    <option
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                      value={value}
                      key={value}
                    >
                      {" "}
                      Show {value}
                    </option>
                  );
                })}
              </select>

              <div>
              
              </div>
              <div className="d-flex align-items-center">
                <span className="d-block">Search</span>
                <input
                  className="form-control ms-2"
                  type="text"
                  value={globalSearchValue || ""}
                  onChange={(e) => {
                    onChange(e.target.value);
                    setGlobalSearchValue(e.target.value);
                  }}
                />
              </div>
            </div> */}

            <div>
              {selectedFlatRows.length > 0 && (
                <button onClick={deletUser}>Delete Users</button>
              )}
            </div>
            <div class="table-responsive">
              <table
                {...getTableProps()}
                id="example"
                className="table table-striped table-bordered dataTable table-sm"
                style={{ width: "100%" }}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          className="text-center width_2"
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? "↑"
                                : "↓"
                              : ""}
                          </span>

                          {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} id="campaignTable">
                  {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="text-center"
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
                {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
              </table>
            </div>

            {/* <div className="d-flex justify-content-between">
              <div>
                <span>
                  Page:
                  <strong>
                    {pageIndex + 1} of {pageOptions.length}
                  </strong>
                </span>

                <span>
                  | Go to Page :{""}
                  <input
                    type="number"
                    defaultValue={pageIndex + 1}
                    onChange={(e) => {
                      const pageNumber = e.target.value
                        ? Number(e.target.value) - 1
                        : 0;
                      gotoPage(pageNumber);
                    }}
                    style={{ width: "50px" }}
                  />
                </span>
              </div>

              <div>
           

                <button
                  className="btn btn_primary m-0"
                  type="button"
                  disabled={!canPreviousPage}
                  onClick={() => {
                    previousPage();
                  }}
                >
                  Prev
                </button>

                <button
                  className="btn btn_primary m-0"
                  type="button"
                  disabled={!canNextPage}
                  onClick={() => {
                    nextPage();
                  }}
                >
                  Next
                </button>

             
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
